import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginFormComponent } from './login-form/login-form.component';
import { AdminGuard } from './admin/admin.guard';
import { AdminLayoutComponent } from './admin/admin-layout/admin-layout.component';
import { UsersListComponent } from './admin/users-list/users-list.component';
import { UserEditComponent } from './admin/user-edit/user-edit.component';
import { GroupsListComponent } from './admin/groups-list/groups-list.component';
import { GroupEditComponent } from './admin/group-edit/group-edit.component';
import { LocationsListComponent } from './admin/locations-list/locations-list.component';
import { LocationEditComponent } from './admin/location-edit/location-edit.component';
import { NoAccessComponent } from './admin/no-access/no-access.component';

const routes: Routes = [
  { path: '', component: LoginFormComponent },
  { path: 'no-access', component: NoAccessComponent },
  {
    path: 'admin',
    component: AdminLayoutComponent,
    canActivate: [AdminGuard],
    children: [
      { path: '', redirectTo: 'users', pathMatch: 'full' },
      { path: 'users', component: UsersListComponent },
      { path: 'users/new', component: UserEditComponent },
      { path: 'users/:id', component: UserEditComponent },
      { path: 'groups', component: GroupsListComponent },
      { path: 'groups/new', component: GroupEditComponent },
      { path: 'groups/:id', component: GroupEditComponent },
      { path: 'locations', component: LocationsListComponent },
      { path: 'locations/new', component: LocationEditComponent },
      { path: 'locations/:id', component: LocationEditComponent }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
